import { db } from "common/config/Firebase";

const collectionTask = db.collection('tasks')

const findTasksByState = async (state) => {
    const data = await collectionTask
        .where("state", "in", [`${state}`, state])
        .get()

    return data.docs.map(doc => doc.data())
}

export default findTasksByState;